import {
  Action,
  ActionType,
  IFactorsNEffectsResponse,
} from "models/stressCheck/factorsNEffects";

import createReducer from "redux/createReducer";

export interface IFactorsNEffectsReducerType {
  loading: boolean;
  error?: any;
  factorsNEffectsResponse?: IFactorsNEffectsResponse;
}

const defaultState: IFactorsNEffectsReducerType = {
  loading: false,
  error: null,
  factorsNEffectsResponse: undefined,
};

export const factorsNEffectsReducer =
  createReducer<IFactorsNEffectsReducerType>(defaultState, {
    [ActionType.FACTOR_N_EFFECTS](state: IFactorsNEffectsReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FACTOR_N_EFFECTS_ERROR](
      state: IFactorsNEffectsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.FACTOR_N_EFFECTS_SUCCESS](
      state: IFactorsNEffectsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        factorsNEffectsResponse: action.payload,
      };
    },

    [ActionType.FACTOR_N_EFFECTS_RESET](state: IFactorsNEffectsReducerType) {
      return {
        ...state,
        loading: false,
        factorsNEffectsResponse: undefined,
      };
    },
  });
